<section class="cmn-innerpage-wrapper">
  <div class="inner-content dashboard">
    <div class="head">
      <h2 class="cmn-title">Permissions</h2>
      <button class="cmn-add-btn apply-btn-left" (click)="applyPermissions()">
        Apply
      </button>
    </div>
    <div *ngFor="let module of permissions" class="permissions-wrapper">
      <div class="labelWrapper">
        <label>
          <h6>{{ module.name }}</h6>
          <mat-slide-toggle
            *ngIf="module.linearPermission?.length"
            [checked]="module.checked"
            (change)="toggleModulePermissions(module, $event.checked)"
          ></mat-slide-toggle>
        </label>
        <mat-accordion *ngIf="module.linearPermission?.length">
          <mat-expansion-panel [expanded]="module.checked">
            <mat-expansion-panel-header>
              <mat-panel-title><h5>Permissions</h5></mat-panel-title>
            </mat-expansion-panel-header>
            <div class="dropdownWrapper">
              <label *ngFor="let perm of module.linearPermission">
                <input
                  type="checkbox"
                  [checked]="perm.checked"
                  (change)="
                    togglePermission(perm.id, $any($event.target).checked)
                  "
                />
                {{ perm.name | titlecase }}
              </label>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div *ngFor="let sub of module.subModule" class="labelWrapper">
        <label>
          <h6>{{ sub.name }}</h6>
          <mat-slide-toggle
            [checked]="sub.checked"
            (change)="toggleSubModulePermissions(sub, $event.checked)"
          ></mat-slide-toggle>
        </label>
        <mat-accordion *ngIf="sub.linearPermission?.length">
          <mat-expansion-panel [expanded]="sub.checked">
            <mat-expansion-panel-header>
              <mat-panel-title><h5>Permissions</h5></mat-panel-title>
            </mat-expansion-panel-header>
            <div class="dropdownWrapper">
              <label *ngFor="let perm of sub.linearPermission">
                <input
                  type="checkbox"
                  [checked]="perm.checked"
                  (change)="
                    togglePermission(perm.id, $any($event.target).checked)
                  "
                />
                {{ perm.name | titlecase }}
              </label>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</section>
